<!-- Header -->
<div class="calendar-header">
  <button
    type="button"
    class="calendar-nav"
    (click)="prev(); $event.stopPropagation()"
  >
    <i class="icon--chevron-left icon--sm"></i>
  </button>
  <button
    type="button"
    class="calendar-header__title"
    (click)="toggleView(); $event.stopPropagation()"
  >
    {{ headerLabel }}
    <i class="icon--chevron-down icon--xs calendar-header__chevron"></i>
  </button>
  <button
    type="button"
    class="calendar-nav"
    (click)="next(); $event.stopPropagation()"
  >
    <i class="icon--chevron-right icon--sm"></i>
  </button>
</div>

<!-- Days view -->
<ng-container *ngIf="currentView === 'days'">
  <div class="calendar-weekdays">
    <span *ngFor="let day of weekdays" class="calendar-weekday">{{ day }}</span>
  </div>
  <div class="calendar-grid calendar-grid--days">
    <button
      *ngFor="let cell of calendarDays; trackBy: trackByDay"
      type="button"
      class="calendar-cell calendar-day"
      [class.calendar-day--other-month]="!cell.currentMonth"
      [class.calendar-day--today]="cell.today"
      [class.calendar-day--selected]="cell.selected"
      [class.calendar-day--range-start]="cell.isStart"
      [class.calendar-day--range-end]="cell.isEnd"
      [class.calendar-day--in-range]="cell.inRange"
      [class.calendar-day--disabled]="cell.disabled"
      [disabled]="cell.disabled"
      (click)="onDayClick(cell); $event.stopPropagation()"
      (mouseenter)="onDayHover(cell)"
    >
      {{ cell.day }}
    </button>
  </div>
</ng-container>

<!-- Months view -->
<div class="calendar-grid calendar-grid--months" *ngIf="currentView === 'months'">
  <button
    *ngFor="let label of monthShortLabels; let i = index; trackBy: trackByIndex"
    type="button"
    class="calendar-cell calendar-month"
    [class.calendar-month--current]="isCurrentMonth(i)"
    [class.calendar-month--selected]="isSelectedMonth(i)"
    (click)="selectMonth(i); $event.stopPropagation()"
  >
    {{ label }}
  </button>
</div>

<!-- Years view -->
<div class="calendar-grid calendar-grid--years" *ngIf="currentView === 'years'">
  <button
    *ngFor="let year of years; trackBy: trackByIndex"
    type="button"
    class="calendar-cell calendar-year"
    [class.calendar-year--current]="isCurrentYear(year)"
    [class.calendar-year--selected]="isSelectedYear(year)"
    (click)="selectYear(year); $event.stopPropagation()"
  >
    {{ year }}
  </button>
</div>
